import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M24 2a4 4 0 1 1-3.874 5H4V5h16.126c.444-1.725 2.01-3 3.874-3Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-11 8a4.002 4.002 0 0 1 3.874 3H28v2H16.874a4.002 4.002 0 0 1-7.748 0H4v-2h5.126c.444-1.725 2.01-3 3.874-3Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7 8a4.002 4.002 0 0 1 3.874 3H28v2h-4.126a4.002 4.002 0 0 1-7.748 0H4v-2h12.126c.444-1.725 2.01-3 3.874-3Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
        id="Ic_filter_svg__a"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Ic_filter_svg__a" fillRule="evenodd" />
  </svg>
);
export default SvgIcFilter;
